import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/admin',
  component: DashBoardNav,
  children: [{
    path: '/admin',
    component: () => import('@/components/administration/homeAdmin')
  },
    {
      name: 'cache-Pivot',
      path: '/admin/cachePivot',
      component: () => import('@/components/administration/cache/cachePivot')
    },
    {
      name: 'style-galery',
      path: '/admin/StyleGalery',
      component: () => import('@/components/administration/StyleGalery')
    },
    {
      name: 'gallery-map-style',
      path: '/admin/GalleryMapStyle',
      component: () => import('@/components/administration/GalleryMapStyle')

    },
    {
      path: '/NotificationManager',
      component: () => import('@/components/administration/NotificationManager')
    },
    {
      path: '/admin/Userslist',
      component: () => import('@/components/administration/UsersList')
    },
    {
      path: '/admin/Empresas',
      component: () => import('@/components/administration/CompanyForm')
    },
    {
      path: '/ConfigTable',
      component: () => import('@/components/upload/ConfigTable')
    },
    {
      path: '/NotificationForm',
      component: () => import('@/components/administration/NotificationForm')
    },
    {
      path: '/SettingsForm',
      component: () => import('@/components/administration/SettingsForm')
    },

    {
      path: '/ConfigLayer',
      component: () => import('@/components/administration/layer/ConfigLayer')
    },
    {
      name: 'demo-test',
      path: '/demo-test',
      component: () => import('@/components/administration/DemoTest')
    },


  ]
}]
